import {CircularProgress} from "@nextui-org/react";

function SideBarLoader() {
  return (
    <div className="flex h-[calc(100vh-100px)] w-full max-w-md items-center justify-center rounded-lg border bg-white p-2 shadow-md ">
      <CircularProgress aria-label="Loading..." color="warning" />
    </div>
  );
}

export default SideBarLoader;
